/** One steps table (laws plan §2): the code drawer and the Action plan law panel both read it. */

/** Codes the Action plan's boiler and DEP items read steps from (Leo 10-27). */
export const BOILER_LOW = "boiler_low";
export const DEP_BOILER_REGISTRATION = "dep_boiler_registration";

const SUGGESTED_ACTIONS: Record<string, string[]> = {
  ll97: [
    "Confirm GSF and primary function",
    "Provide ESPM CY2024 site EUI data",
    "Mark as on good-faith compliance plan",
  ],
  ll84: ["Confirm GSF", "Confirm primary function"],
  ll88: ["File lighting + sub-metering attestation"],
  ll33: ["Post energy efficiency grade label"],
  // PR-B (LL87 FR-23/FR-13): public filing records end in 2024, so an
  // accruing figure may already be cured by a filing we cannot see.
  ll87: [
    "Confirm any EER filing you've already made — filed reports post to NYC's public record on a delay",
    "Confirm your building's assigned audit cycle year",
    "Engage an energy auditor and RCx agent (12–18 month lead time)",
  ],
  // 1 RCNY 103-02(c)(4), (c)(5)(i), (e).
  elevator_cat1: [
    "Yearly CAT1 test on each elevator",
    "Report filed with DOB within 21 days of the test",
    "Hazards fixed at once, other defects within 90 days of the test; affirmation of correction filed within 14 days of the fix",
  ],
  elevator_cat3: ["File missing CAT3 reports"],
  elevator_cat5: ["File missing CAT5 reports"],
  // Group 4 (10-10): the row turns Overdue on day 104 (dob_affirmations.py).
  [BOILER_LOW]: [
    "File the yearly inspection in DOB NOW: Safety",
    "After an inspection with defects, file the re-inspection within 104 days",
  ],
  boiler_high: ["File missing boiler CPD"],
  // 1 RCNY 103-04(c)(2)(ii); (a), (c)(4)(iii), (v); (c)(5)(i), (ii), (iv).
  fisp: [
    "Hire a QEWI to examine the facade",
    "QEWI files the report with DOB within your 2-year filing window",
    "Unsafe: protect the public and start repairs at once, fix within 90 days of the report; the QEWI checks within 2 weeks of the fix and files an amended report",
  ],
  ll126: ["File the parking structure inspection report"],
  // 1 RCNY 103-10 (laws plan §3 RT7, §3a 1).
  ll152: [
    "Confirm Community District inspection year",
    "Licensed Master Plumber inspects; GPS1 report to you within 30 days",
    "LMP files the GPS2 certification with DOB within 60 days",
    "Certify fixes within 120 days",
  ],
  hpd_registration: ["File HPD property registration"],
  // AC 27-2018.2 (the report; posted within 60 days), 27-2018.1(c) (tenant copy); LL69/2017, laws plan §3a 16.
  bedbug_report: [
    "File annual bedbug report",
    "Give tenants a copy at lease or renewal, or post it within 60 days of filing.",
    "Corporate owners file online.",
  ],
  cooling_tower: ["File annual cooling tower certification"],
  [DEP_BOILER_REGISTRATION]: [
    "Renew in DEP CATS within 180 days before the expiry",
  ],
  elevator_periodic_inspection: [
    "Book an approved elevator agency at least 3 months from the CAT1 test or last inspection",
    "After an inspection with defects, file the correction affirmation within 104 days",
  ],
  elevator_single_plunger_brake: [
    "Have your elevator agency file the brake permit in DOB NOW: Build and get it signed off",
  ],
  // 1 RCNY 103-15; DOB's parapet FAQ (FISP report, FISP3).
  parapet_observation: [
    "Have a competent person observe each street-facing parapet every year and keep the report 6 years",
    "A FISP report filed that year counts if it covers everything 1 RCNY 103-15 asks for",
    "Unsafe: call 311 and protect the public at once; a FISP building also files a FISP3",
  ],
  self_closing_doors: [
    "Fix the door so it closes and latches by itself, then certify the repair to HPD",
  ],
  heat_hot_water: [
    "Fix what the NOV names: no heat, no hot water, or water too hot (anti-scald). Then certify the repair to HPD",
  ],
  required_postings: [
    "Post the notice the violation names, then certify the correction to HPD",
  ],
  hpd_egress_locks: [
    "Fix the lock, gate or fire escape the violation names, then certify the repair to HPD",
  ],
  window_guards: [
    "Install or repair the window guards the violation names, then certify the repair to HPD",
  ],
  ll55_indoor_allergens: [
    "Fix the mold or pests the violation names and their cause, then certify the correction to HPD",
  ],
};

/** Empty for unmapped codes; the drawer then hides the section. */
export const suggestedActionsForCode = (codeId: string): string[] =>
  SUGGESTED_ACTIONS[codeId] ?? [];
